import Ajv from 'ajv';
import _ from 'lodash';
import enums from '../../common/utils/enums';
import { convertToBps } from '../../common/utils';
import registrationSchema from './registration.json';

function businessHourStartTimeBeforeEndTime() {
  return (data) =>
    data && (data.startTime || data.endTime)
      ? data.startTime < data.endTime
      : true;
}

function driveMustHaveAtLeastOneInStock() {
  return (data) => _.some(data, (drive) => drive.totalStock >= 0);
}

function deliveryOptionsMustNotOverlap() {
  return (data) => {
    const sorted = _.sortBy(data, ['max', 'unit']);
    for (let i = 1; i < sorted.length; i++) {
      const v1 = sorted[i - 1];
      const v2 = sorted[i];
      if (v1.unit === v2.unit && v1.max === v2.max) {
        return false;
      }
    }
    return true;
  };
}

function noDuplicatePhoneNumbers() {
  return (data) => {
    return (
      data &&
      _.uniqBy(data, (o) => o.intlCode + o.phoneNo).length === data.length
    );
  };
}

function noDuplicateEmails() {
  return (data) => {
    return data && _.uniqBy(data, (o) => o.email).length === data.length;
  };
}

function doesBandwidthExceedMaxInTbps() {
  return (data) => {
    if (data && data.unit) {
      const bandwidth = { value: data.value, unit: data.unit };
      const bandwidthInBps = convertToBps(bandwidth);
      const maxAllowedValueInBps =
        1000 * enums.BandwidthInBps.TERA_BITS_PER_SECOND;
      return bandwidthInBps < maxAllowedValueInBps;
    }
  };
}

const Schema = new Ajv({
  allErrors: true,
  strict: false,
  unicodeRegExp: false,
});

Schema.addKeyword({
  keyword: 'businessHourStartTimeBeforeEndTime',
  compile: businessHourStartTimeBeforeEndTime,
});
Schema.addKeyword({
  keyword: 'driveMustHaveAtLeastOneInStock',
  compile: driveMustHaveAtLeastOneInStock,
});
Schema.addKeyword({
  keyword: 'deliveryOptionsMustNotOverlap',
  compile: deliveryOptionsMustNotOverlap,
});
Schema.addKeyword({
  keyword: 'noDuplicatePhoneNumbers',
  compile: noDuplicatePhoneNumbers,
});
Schema.addKeyword({ keyword: 'noDuplicateEmails', compile: noDuplicateEmails });
Schema.addKeyword({
  keyword: 'doesBandwidthExceedMaxInTbps',
  compile: doesBandwidthExceedMaxInTbps,
});

for (let key in registrationSchema) {
  Schema.addSchema(registrationSchema[key]);
}

export default Schema;
